import React, { useContext } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Card, Grid } from "@material-ui/core";
import Typography from "@components/Typography";
import PriceFormat from "@components/PriceFormat";
import { useParams } from "react-router-dom";
import { StatsContext } from "@context/statsContext";

const TradeVolume = () => {
  const classes = useStyles();
  const { statsState } = useContext(StatsContext);
  const { currencyName } = useParams();
  const statItem = statsState?.stats[currencyName?.replace("-", "_")];
  const dayClose = statItem?.dayClose;

  const checkColor = (price) => {
    if (price > dayClose) {
      return "primary.tint90";
    } else if (price < dayClose) {
      return "red2.main";
    } else {
      return "";
    }
  };
  return (
    <Card elevation={0} className={classes.card}>
      <div className={classes.unitContainer}>
        <Typography className={classes.unitText}>
          {currencyName?.split("-")[1] === "IRT" ? __t("toman") : __t("Tether")}{" "}
        </Typography>
      </div>
      <Grid
        container
        direction="row"
        alignItems="center"
        className={classes.priceContainer}
      >
        <Grid
          item
          container
          direction="column"
          alignItems="center"
          justify="space-evenly"
          className={classes.priceItemsContainer}
        >
          <Typography color={checkColor(statItem?.dayHigh)}>
            <PriceFormat price={statItem?.dayHigh} />
          </Typography>
          <Typography variant="3xs" className={classes.priceItemText}>
            {__t("Highest Price")}
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="column"
          alignItems="center"
          justify="space-evenly"
          className={classes.priceItemsContainer}
        >
          <Typography color={checkColor(statItem?.unitPrice)}>
            <PriceFormat price={statItem?.unitPrice} />
          </Typography>
          <Typography variant="3xs" className={classes.priceItemText}>
            {__t("The Last Deal")}
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="column"
          alignItems="center"
          justify="space-evenly"
          className={classes.priceItemsContainer}
        >
          <Typography color={checkColor(statItem?.dayLow)}>
            <PriceFormat price={statItem?.dayLow} />
          </Typography>
          <Typography variant="3xs" className={classes.priceItemText}>
            {__t("The Lowest Price")}
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="column"
          alignItems="center"
          justify="space-evenly"
          className={classes.priceItemsContainer}
        >
          <Typography>
            <PriceFormat price={statItem?.volumeDst} />
          </Typography>
          <Typography variant="3xs" className={classes.priceItemText}>
            {__t("Volume 24 hours")}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default TradeVolume;
